import { useContext } from 'react'

import { AssetsContext } from '../providers/Assets'

export function useIcon(icon: string | Array<string>): { alt: string; src: string; height: string; width: string; } {
  const isString = typeof icon === 'string'
  const context = useContext(AssetsContext)
  const icons = context?.assets?.icons
  const iconSelected = icons.find((i) => i.name === icon)

  const filterArrayOfNames = (d) => d.map((i) => icons.find((s) => s.name === i))
  const iconsSelected = !isString && filterArrayOfNames(icon)

  if (isString) {
    return {
      alt: iconSelected?.name,
      src: iconSelected?.url,
      height: iconSelected?.height,
      width: iconSelected?.width
    }
  } else {
    return iconsSelected
  }
}
